import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { withCookies } from 'react-cookie';
import {
    Button,
    Grid
} from '@material-ui/core';
import axios from 'axios';
import Common from '../../Common';

const styles = () => ({
    displayFlex: {
        display: 'flex'
    },
    verticalSpace: {
        margin: '25px 20px 20px 150px',
    },
    searchButtonSpace: {
        margin: '25px 0px 20px 100px',
    }
});

const SearchButton = withCookies((props) => {
    const {
        classes,
        recordId,
        memo,
        creationDate,
        address,
        reportDate,
        endFlg,
        categoryId,
        shubetsuId,
        setData,
        cookies,
        setAllUpdate,
        setIsLoading
    } = props;

    const setUserDatas = () => {
        setAllUpdate(false);
        setIsLoading(true);
        axios.post(
            `${Common.apiServerUrl()}/api/supponet/user`,
            {
                recordId,
                memo,
                creationDate,
                address,
                reportDate,
                endFlg: endFlg.length !== 0 ? endFlg : '',
                categoryId: categoryId.length !== 0 ? categoryId : '',
                shubetsuId: shubetsuId.length !== 0 ? shubetsuId : '',
            },
            {
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    Authorization: 'Bearer ' + cookies.get('access_token'),
                    'x-suppportcenter-token': cookies.get('token'),
                    'x-jichitai-jichitaiid': cookies.get('x-jichitai-jichitaiid'),
                    'x-jichitai-token': cookies.get('x-jichitai-token'),
                },
                data: {},
            }
        )
        .then(Common.handleErrors)
        .then((res) => {
            if (res.success) {
                if(res.result.length === 0) window.alert('絞り込み条件に合致する結果が⾒つかりませんでした。');
                setData(res.result);
            } else {
                window.alert(`code : [${res.type}]\nmessage : ${res.message}`);
            }
        })
        .catch((err) => {
            console.error('Line.js checkedKiboNinzu:get err:' + err.message);
        })
        .finally(() => {
            setIsLoading(false);
        });
    };

    return (
        <React.Fragment>
            <Grid>
                <div>
                    <div className={classes.displayFlex + ' ' + classes.verticalSpace}>
                        <Button color="primary" size="large" className={classes.searchButtonSpace} variant="contained" onClick={() => setUserDatas()}>検索</Button>
                    </div>
                </div>
            </Grid>
        </React.Fragment>
    );
});

SearchButton.propTypes = {
    classes: PropTypes.object.isRequired,
    recordId: PropTypes.string.isRequired,
    memo: PropTypes.string.isRequired,
    setData: PropTypes.func.isRequired,
    creationDate: PropTypes.string.isRequired,
    address: PropTypes.string.isRequired,
    reportDate: PropTypes.string.isRequired,
    endFlg: PropTypes.array.isRequired,
    categoryId: PropTypes.array.isRequired,
    shubetsuId: PropTypes.array.isRequired,
    cookies: PropTypes.object.isRequired,
};

export default withStyles(styles)(SearchButton);